import React, { useState, useEffect } from "react";
import {
  AccordionDetails,
  AccordionSummary,
  Typography,
  Button,
  TextField,
  Box,
  Accordion,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import TypeAutoComplete from "../../basic-information/productType/TypeAutoComplete";
import MaterialAutoComplete from "../../basic-information/productMaterial/MaterialAutoComplete";
import SizeAutoComplete from "../../basic-information/productSize/SizeAutoComplete";
import ColorAutoComplete from "../../basic-information/productColor/ColorAutoComplete";
import TasteAutoComplete from "../../basic-information/productTaste/TasteAutoComplete";
import ScentAutoComplete from "../../basic-information/smell/ScentAutoComplete";
import ShieldAutoComplete from "../../basic-information/productShield/ShieldAutoComplete";
import { UseProduct } from "./UseProduct";
import { useSnackbar } from "notistack";
import useBreakpoints from "../../hooks/useBreakpoints";

export default function Level2(props) {
  const { enqueueSnackbar } = useSnackbar();
  const { validateLvl2Edit } = UseProduct();
  const [level2, setLevel2] = React.useState({
    countInPack: null,
    registerCode: "",
    consumerAge: "",
    gender: "",
    weight: "",
    spf: "",
    typeID: "",
    materialID: "",
    sizeID: "",
    colorID: "",
    tasteID: "",
    scentID: "",
    shieldID: "",
  });
  const { isSmall } = useBreakpoints();

  const [stateValidation, setStateValidation] = useState({
    typeID: false,
    weight: false,
  });

  useEffect(() => {
    if (props.fireGetData) {
      props.getDataFromLevel2(level2);
    }
  }, [props.fireGetData]);

  return (
    <Accordion
      expanded={props.expanded === "panel2"}
      style={{ margin: "20px", paddingBottom: "15px" }}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel1bh-content"
        id="panel1bh-header"
      >
        <Typography sx={{ width: "33%", flexShrink: 0 }}>مرحله دوم</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Box>
          <Box display="grid" gridTemplateColumns="repeat(12, 1fr)" gap={3}>
            <Box gridColumn={isSmall ? "span 12" : "span 3"}>
              <TypeAutoComplete
                validation={stateValidation.typeID}
                setter={setLevel2}
                lvl2State={level2}
              ></TypeAutoComplete>
            </Box>
            <Box gridColumn={isSmall ? "span 12" : "span 3"}>
              <MaterialAutoComplete
                setter={setLevel2}
                lvl2State={level2}
              ></MaterialAutoComplete>
            </Box>
            <Box gridColumn={isSmall ? "span 12" : "span 3"}>
              <SizeAutoComplete
                setter={setLevel2}
                lvl2State={level2}
              ></SizeAutoComplete>
            </Box>
            <Box gridColumn={isSmall ? "span 12" : "span 3"}>
              <ColorAutoComplete
                setter={setLevel2}
                lvl2State={level2}
              ></ColorAutoComplete>
            </Box>
            <Box gridColumn={isSmall ? "span 12" : "span 3"}>
              <TasteAutoComplete
                setter={setLevel2}
                lvl2State={level2}
              ></TasteAutoComplete>
            </Box>
            <Box gridColumn={isSmall ? "span 12" : "span 3"}>
              <ScentAutoComplete
                setter={setLevel2}
                lvl2State={level2}
              ></ScentAutoComplete>
            </Box>
            <Box gridColumn={isSmall ? "span 12" : "span 3"}>
              <ShieldAutoComplete
                setter={setLevel2}
                lvl2State={level2}
              ></ShieldAutoComplete>
            </Box>
            {!isSmall && <Box gridColumn="span 3"></Box>}
            <Box gridColumn={isSmall ? "span 12" : "span 2"}>
              <TextField
                type="number"
                id="outlined-basic"
                value={level2.countInPack ? level2.countInPack : ""}
                label=" تعداد در بسته "
                variant="outlined"
                onChange={(event) => {
                  if (event.target.value) {
                    setLevel2({
                      ...level2,
                      countInPack: event.target.value,
                    });
                  } else {
                    setLevel2({
                      ...level2,
                      countInPack: null,
                    });
                  }
                }}
                size="small"
                fullWidth
              />
            </Box>
            <Box gridColumn={isSmall ? "span 12" : "span 2"}>
              <TextField
                type="number"
                id="outlined-basic"
                value={level2.weight}
                error={stateValidation.weight}
                label=" وزن "
                variant="outlined"
                onChange={(event) => {
                  setLevel2({
                    ...level2,
                    weight: event.target.value,
                  });
                }}
                size="small"
                fullWidth
              />
            </Box>
            <Box gridColumn={isSmall ? "span 12" : "span 2"}>
              <TextField
                id="outlined-basic"
                value={level2.consumerAge}
                label="سن مصرف"
                variant="outlined"
                onChange={(event) => {
                  setLevel2({
                    ...level2,
                    consumerAge: event.target.value,
                  });
                }}
                size="small"
                fullWidth
              />
            </Box>
          </Box>
        </Box>
        <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 3 }}>
          <Button
            sx={{ mr: 2, width: "100px" }}
            variant="outlined"
            color="secondary"
            size="small"
            onClick={() => {
              props.setExpanded("panel1");
            }}
          >
            مرحله قبل
          </Button>
          <Button
            sx={{ width: "100px" }}
            variant="contained"
            color="secondary"
            size="small"
            onClick={() => {
              validateLvl2Edit(level2, setStateValidation, () => {
                enqueueSnackbar("مرحله دوم با موفقیت تکمیل شد", {
                  variant: "success",
                  autoHideDuration: 2000,
                });
                props.setExpanded("panel3");
              });
            }}
          >
            مرحله بعد
          </Button>
        </Box>
      </AccordionDetails>
    </Accordion>
  );
}
